import { Component, OnInit, Input } from '@angular/core'
import moment from 'moment'

@Component({
  selector: 'post-thirty-day-message',
  styles: [`
    :host {
      display: inline;
    }
  `],
  template: `
    <i class="fas fa-exclamation-circle text-danger"
      tooltip="{{writerName}} has been waiting over {{sentAgoString}}"
      containerClass="white-tooltip"></i>
  `
})
export class PostThirtyDayMessage implements OnInit {
  @Input() writerName: string;
  @Input() postSentAt: Date;
  sentAtDate: moment.Moment;

  ngOnInit(): void {
    this.sentAtDate = moment(this.postSentAt)
  }

  get sentAgoString(): string {
    return this.sentAtDate.fromNow(true)
  }
}
